import { IAlarmSettings } from 'plugin-codaf-risk-ext-bowtie/types/alarms'
import { BOWTIE_BASE_URL, DRA_ALARM_SETTINGS } from 'plugin-codaf-risk-ext-bowtie/utils/constants'

export const createAlarmSettings = async (body: IAlarmSettings): Promise<IAlarmSettings> => {
    return fetch(`${BOWTIE_BASE_URL}/${DRA_ALARM_SETTINGS}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}

export const deleteAlarmSettings = async (username: string): Promise<void> => {
    return fetch(`${BOWTIE_BASE_URL}/${DRA_ALARM_SETTINGS}/${username}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}

export const getAlarmSettings = async (username: string): Promise<IAlarmSettings> => {
    return fetch(`${BOWTIE_BASE_URL}/${DRA_ALARM_SETTINGS}/${username}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}

export const updateAlarmSettings = async (body: IAlarmSettings): Promise<IAlarmSettings> => {
    return fetch(`${BOWTIE_BASE_URL}/${DRA_ALARM_SETTINGS}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}
